import styled from 'styled-components'
import { Link } from 'gatsby'
import { breakpoints } from '../../styles/global'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const AnnouncementBar = styled.div`
  background: transparent;
  border-bottom: 1px solid #0000002b;
  color: #333;
  font-size: 13px;
  padding: 13px;
  text-align: center;
  font-weight: bold;
`

export const HeaderWrapper = styled.div`
  position: ${props => (props.floating ? 'absolute' : 'relative')};
  color: ${props => (props.floating ? 'white' : 'black')};
  z-index: ${props => (props.floating ? '2' : '')};
  width: ${props => (props.floating ? '100%' : '')};
  top: ${props => (props.floating ? '0' : '')};
  left: ${props => (props.floating ? '0' : '')};
  right: ${props => (props.floating ? '0' : '')};
`

export const Wrapper = styled.header`
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
  padding-bottom: 30px;
  align-items: center;
  flex-wrap: wrap;
`

export const NavItems = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
  flex-wrap: wrap;
`

export const NavItem = styled.li`
  margin-left: 40px;

  @media (max-width: ${breakpoints.max.laptop}px) {
    display: ${props => (props.desktopOnly ? 'none' : '')};
  }

  @media (min-width: ${breakpoints.min.laptop}px) {
    display: ${props => (props.mobileOnly ? 'none' : '')};
  }
`

export const NavLink = styled(Link)`
  text-decoration: none;
  color: ${props => (props.inverted ? 'white' : 'black')};
`

export const Logo = styled(Link)`
  text-decoration: none;
  color: black;
  font-weight: 700;
  font-size: 1.5rem;
  color: ${props => (props.inverted ? 'white' : 'black')};
`

export const CartButton = styled.button`
  background: none;
  border: none;
  width: none;
  padding: 0;
  margin: none;
  cursor: pointer;

  & svg {
    height: 2rem;
    width: 2rem;
    padding-bottom: 2px;
    fill: ${props => (props.inverted ? 'white' : 'black')};
  }
`

export const CartIcon = styled.img`
  height: 2rem;
  padding-bottom: 2px;
`

export const HamburgerIcon = styled(FontAwesomeIcon)`
  color: ${props => (props.inverted ? 'white' : 'black')};
  font-size: 20px;
`
